import { AutoLinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { InitialConfigType } from '@lexical/react/LexicalComposer';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';

import { MergeTagNode } from '../plugins/MergeTagPlugin';
import EditorTheme from '../themes/EditorTheme';
import { EditorThemeClasses } from 'lexical';

interface RichTextEditorProviderProps {
  children: React.ReactNode;
  namespace?: string;
  theme?: EditorThemeClasses;
}

export function RichTextEditorProvider({ children, theme = EditorTheme, namespace = 'RichTextEditor' }: RichTextEditorProviderProps) {
  const initialConfig: InitialConfigType = {
    namespace: namespace,
    theme: theme,
    onError: console.error,
    nodes: [AutoLinkNode, HeadingNode, ListItemNode, ListNode, MergeTagNode, QuoteNode],
  };

  return <LexicalComposer initialConfig={initialConfig}>{children}</LexicalComposer>;
}
